/* eslint-disable no-undef */
let setTimeoutId = 0;

export function showControls(config) {
  const myTarget = document.getElementById(config.targetContentId);
  if (setTimeoutId) clearTimeout(setTimeoutId);
  if (myTarget.classList.contains('show-controls')) {
    myTarget.classList.remove('show-controls');
  } else {
    myTarget.classList.add('show-controls');
  }

  setTimeoutId = setTimeout(() => {
    if (myTarget.classList.contains('show-controls')) {
      myTarget.classList.remove('show-controls');
    }
  }, 6000);
}

export function activateClickToShowControls(config) {
  const myTarget = document.getElementById(config.targetContentId);
  myTarget.addEventListener('click', (event) => {
    if (event.target.id !== 'tpx-simple-playlist') return;
    showControls(config);
  });
}
